<template>
  <button
    class="button--answer"
    @click.prevent="performAction(answer)">
    <img
      class="answer-image"
      v-if="answer.image"
      :src="answer.image"
    />
    <div class="answer-text">
      <slot />
    </div>
  </button>
</template>

<script>
  export default {
    props: [
      'answer'
    ]
  }
</script>

<style lang="scss" scoped>
  .button--answer {
    @apply
      flex
      h-full
      w-full
      mb-3.5
      rounded
      min-h-15
      items-center
      bg-ctm-tertiary;

    .answer-image {
      @apply
        w-full
        h-full
        rounded
        max-w-22.5
        flex-grow-0
        object-cover
        flex-shrink-0;
    }

    .answer-text {
      @apply
        mx-3
        w-full
        text-sm
        text-left
        text-ctm-black;
    }
  }
</style>